<template>
  <div class="w-full border-2 border-orange p-4">
    <h2 class="mb-4 text-2xl font-bold text-orange">
      Can't decide who to contact?
    </h2>
    <h3 class="text-lg text-blue-30 hover:text-blue-80 hover:underline">
      <a href="/employers/details"
        >Submit your requirements to Agency Central and let us find you the best
        agencies!</a
      >
    </h3>
    <span class="text-grey-60">
      Save yourself hours of searching by
      <a
        class="font-bold text-grey-80 underline hover:text-grey-100"
        href="/employers/details"
      >
        uploading your job requirements.</a
      >
      Our specially trained staff will pick out the perfect agencies on your
      behalf, ensuring you get the best candidates.
    </span>
  </div>
</template>

<script>
export default {
  name: 'AdvertEmployerDetails',
};
</script>
